import { TopBarButton } from "components/PageTopNavV2/styled";
import styled from "styled-components";
import { rotatingShineAnimation } from "../../animations";

export const MenuButtonHighlight = styled.div<{
	$height: number;
	$left: number;
	$top: number;
	$width: number;
}>`
	position: fixed;
	top: ${({ $top }) => `${$top}px`};
	left: ${({ $left }) => `${$left}px`};
	width: ${({ $width }) => `${$width}px`};
	height: ${({ $height }) => `${$height}px`};
	font-size: 10px;
	z-index: 10002;
	pointer-events: none;
`;

export const MenuButtonShine = styled.img`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 13.2em;
	height: 13.2em;
	opacity: 0.8;
	z-index: 0;
	${rotatingShineAnimation}
`;

export const SelectedMenuButton = styled(TopBarButton)`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	z-index: 1;
	transition: none;
	cursor: default;

	svg {
		width: 22px;
		height: 29px;
	}
`;
